import type { EditorPlugin } from '../../../types/aha-editor';
import BoldMarkPlugin from './BoldMarkPlugin';
import MarkdownPlugin from '../../MarkdownPlugin/MarkdownPlugin';
import { markdownRegexpForMark } from '../../MarkdownPlugin/MarkdownUtils';

const BoldMarkdownPlugin: EditorPlugin = {
  name: 'Bold Mark Markdown plugin',
  dependencies: [MarkdownPlugin, BoldMarkPlugin],
  markdown: ['*', '_'].map((char) => ({
    type: 'mark',
    mark: 'bold',
    triggerCharacter: char,
    regex: markdownRegexpForMark(`${char}${char}`),
  })),
};

export default BoldMarkdownPlugin;
